<template>
  <div class="flexLeftRow connectionBox">
    <div id="statusDot"></div>
    <h3>{{ connectionCount }} live connections</h3>
  </div>
</template>

<script>
export default {
  name: "RawLink",
  props: {
    connectionCount: Number,
  },
  components: {},
  data() {
    return {};
  },
  methods: {},
  setup() {
    return {};
  },
};
</script>

<style scoped>
.connectionBox {
  background-color: #721cff20;
  border: 1px solid #721cff80;
  border-radius: 30px;
  padding: 7px 12px;
  cursor: pointer;
}
#statusDot {
  height: 9px;
  width: 9px;
  background: green;
  border-radius: 50%;
  margin-right: 10px;
  box-shadow: 0 0 0 0 rgba(40, 167, 69, 0.7);
  animation: pulse 2s infinite;
}
@keyframes pulse {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(40, 167, 69, 0.7);
  }
  70% {
    transform: scale(1.2);
    box-shadow: 0 0 0 10px rgba(40, 167, 69, 0);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(40, 167, 69, 0);
  }
}
</style>
